! function() {
    "use strict";
    var t = {
            4105: function(t, e, i) {
                i.d(e, {
                    hO: function() {
                        return n
                    },
                    zx: function() {
                        return r
                    }
                });
                const n = function() {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    const e = window.innerWidth - document.body.offsetWidth,
                        i = document.getElementById("nav-wrapper");
                    t ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = e + "px", i.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", i.style.paddingRight = "0px")
                };
                document.querySelectorAll(".local-scroll").forEach((t => {
                    t.addEventListener("click", (t => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        (t => {
                            Math.easeInOutQuad = function(t, e, i, n) {
                                return (t /= n / 2) < 1 ? i / 2 * t * t + e : -i / 2 * (--t * (t - 2) - 1) + e
                            };
                            const e = document.getElementById("grid-archive-header"),
                                i = document.getElementById("nav-wrapper");
                            let n = 0,
                                o = 0;
                            e && (n = e.offsetHeight + 50), i && (o = i.offsetHeight + 50);
                            const r = t.offsetTop - n - o,
                                a = window.scrollY,
                                s = r - a;
                            let c = 0;
                            const d = () => {
                                c += 5;
                                const t = Math.easeInOutQuad(c, a, s, 200);
                                window.scrollTo(0, t), c < 200 && setTimeout(d, 5)
                            };
                            d()
                        })(document.querySelector(e))
                    }))
                }));
                const o = {};

                function r(t) {
                    document.removeEventListener("focusin", o.focusin), document.removeEventListener("focusout", o.focusout), document.removeEventListener("keydown", o.keydown), t && t.focus()
                }
            }
        },
        e = {};

    function i(n) {
        var o = e[n];
        if (void 0 !== o) return o.exports;
        var r = e[n] = {
            exports: {}
        };
        return t[n](r, r.exports, i), r.exports
    }
    i.d = function(t, e) {
            for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            })
        }, i.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        },
        function() {
            var t = i(4105);
            document.addEventListener("DOMContentLoaded", (function() {
                document.querySelectorAll(".icon").forEach((t => {
                    t.classList.add("loaded")
                })), document.querySelectorAll('a[target="_blank"]').forEach((t => {
                    t.innerHTML = t.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>"
                }))
            })), void 0 !== window.BOOMR && console.log("Built with " + window.BOOMR.themeName + " (https://themes.shopify.com/themes/align/) version " + window.BOOMR.themeVersion + " by Company XYZ (https://ekahal.com/)."), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(t, e) {
                return function() {
                    return t.apply(e, arguments)
                }
            }, Shopify.setSelectorByValue = function(t, e) {
                for (var i = 0, n = t.options.length; i < n; i++) {
                    var o = t.options[i];
                    if (e == o.value || e == o.innerHTML) return t.selectedIndex = i, i
                }
            }, Shopify.addListener = function(t, e, i) {
                t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i)
            }, Shopify.postLink = function(t, e) {
                var i = (e = e || {}).method || "post",
                    n = e.parameters || {},
                    o = document.createElement("form");
                for (var r in o.setAttribute("method", i), o.setAttribute("action", t), n) {
                    var a = document.createElement("input");
                    a.setAttribute("type", "hidden"), a.setAttribute("name", r), a.setAttribute("value", n[r]), o.appendChild(a)
                }
                document.body.appendChild(o), o.submit(), document.body.removeChild(o)
            }, Shopify.CountryProvinceSelector = function(t, e, i) {
                this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(i.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
            }, Shopify.CountryProvinceSelector.prototype = {
                initCountry: function() {
                    var t = this.countryEl.getAttribute("data-default");
                    Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
                },
                initProvince: function() {
                    var t = this.provinceEl.getAttribute("data-default");
                    t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
                },
                countryHandler: function(t) {
                    var e = (o = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                        i = JSON.parse(e);
                    if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
                    else {
                        for (var n = 0; n < i.length; n++) {
                            var o;
                            (o = document.createElement("option")).value = i[n][0], o.innerHTML = i[n][1], this.provinceEl.appendChild(o)
                        }
                        this.provinceContainer.style.display = ""
                    }
                },
                clearOptions: function(t) {
                    for (; t.firstChild;) t.removeChild(t.firstChild)
                },
                setOptions: function(t, e) {
                    var i = 0;
                    for (e.length; i < e.length; i++) {
                        var n = document.createElement("option");
                        n.value = e[i], n.innerHTML = e[i], t.appendChild(n)
                    }
                }
            };
            const e = () => {
                var t = [].slice.call(document.querySelectorAll("img"));
                if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
                    let e = new IntersectionObserver((function(t, e) {
                        t.forEach((function(t) {
                            if (t.isIntersecting) {
                                let i = t.target;
                                i.classList.contains("loaded") || (i.classList.add("loaded"), e.unobserve(i))
                            }
                        }))
                    }));
                    t.forEach((function(t) {
                        e.observe(t)
                    }))
                }
            };
            e(), document.querySelectorAll("video").forEach((t => {
                t.muted = !0;
                let e = t.play();
                void 0 !== e && e.then((e => {
                    new IntersectionObserver((e => {
                        e.forEach((e => {
                            e.isIntersecting || t.paused ? t.paused && t.autoplay && t.play() : t.pause()
                        }))
                    }), {
                        threshold: 0
                    }).observe(t)
                }))
            }));
            const n = function() {
                [].slice.call(document.querySelectorAll("video")).forEach((t => {
                    const e = t.parentElement.querySelector(".figure--video__poster");
                    e && e.addEventListener("click", (() => {
                        e.classList.add("hidden"), t.play()
                    }))
                }));
                var t = [].slice.call(document.querySelectorAll(".figure--video-external"));
                if ("IntersectionObserver" in window) {
                    var e = new IntersectionObserver((function(t, e) {
                        t.forEach((function(t) {
                            if (t.isIntersecting) "vimeo" == t.target.dataset.type && fetch("http://vimeo.com/api/v2/video/" + t.target.dataset.id + ".json").then((t => {
                                if (!t.ok) throw new Error(`HTTP error ${t.status}`);
                                return t.json()
                            })).then((e => {
                                t.target.querySelector(".figure--video__external-poster-image").src = e[0].thumbnail_large
                            })), t.target.addEventListener("click", (function() {
                                if (!t.target.querySelector("iframe")) {
                                    let t = this.dataset.type,
                                        e = document.createElement("iframe");
                                    e.setAttribute("frameborder", "0"), e.setAttribute("allowfullscreen", ""), e.setAttribute("allow", "autoplay"), "youtube" == t ? (e.setAttribute("id", "youtube"), e.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1")) : e.setAttribute("src", "https://player.vimeo.com/video/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"), this.querySelector(".figure--video__poster").classList.add("hidden"), this.appendChild(e)
                                }
                            }));
                            else if (t.target.querySelector("iframe")) {
                                let i = t.target.dataset.type,
                                    n = t.target.querySelectorAll("iframe");
                                if ("youtube" == i) {
                                    var e = {
                                        event: "command",
                                        func: "pauseVideo"
                                    };
                                    n[0].contentWindow.postMessage(JSON.stringify(e), "*")
                                } else "vimeo" == i && (e = {
                                    method: "pause",
                                    value: "true"
                                }, n[0].contentWindow.postMessage(JSON.stringify(e), "*"))
                            }
                        }))
                    }));
                    t.forEach((function(t) {
                        e.observe(t)
                    }))
                }
            };
            n(), window.addEventListener("beforeprint", (() => {
                const t = document.body.querySelectorAll("details"),
                    e = document.body.querySelectorAll("img");
                for (let e = 0; e < t.length; e++) t[e].open ? t[e].dataset.open = "1" : t[e].setAttribute("open", "");
                for (let t = 0; t < e.length; t++) e[t].dataset.open = "1"
            })), window.addEventListener("afterprint", (() => {
                const t = document.body.querySelectorAll("details");
                for (let e = 0; e < t.length; e++) t[e].dataset.open ? t[e].dataset.open = "" : t[e].removeAttribute("open")
            })), Shopify.designMode && document.addEventListener("shopify:section:load", (() => {
                n(), document.querySelectorAll(".icon").forEach((t => {
                    t.classList.add("loaded")
                })), document.querySelectorAll("img").forEach((t => {
                    t.classList.add("loaded")
                }))
            }));
  
         class newradio extends HTMLElement {
                constructor() {
                    super(), this.addEventListener("change", this.onVariantChange)
                }
                onVariantChange() {
                    this.updateOptions(), this.updateMasterId(), this.updateVariantStatuses(), this.updateImageSwatches(), this.currentVariant ? (this.updateMediaThumbs(), this.updateURL(), this.renderProductInfo(), this.updateVariantInput(), this.toggleStockStatus(this.currentVariant.available)) : this.setUnavailable()
                }
                updateOptions() {
                    this.options = Array.from(this.querySelectorAll("select, fieldset"), (t => "SELECT" === t.tagName ? t.value : "FIELDSET" === t.tagName ? Array.from(t.querySelectorAll("input")).find((t => t.checked))?.value : void 0))
                }
                updateMasterId() {
                    this.currentVariant = this.getVariantData().find((t => !t.options.map(((t, e) => this.options[e] === t)).includes(!1)))
                }
                updateVariantStatuses() {
                    const t = this.querySelector(":checked").value,
                        e = this.getVariantData().filter((e => e.options[0] === t));
                    this.getProductVariantSelects().forEach((t => {
                        const n = t.querySelectorAll("select, fieldset");
                        n.forEach(((t, i) => {
                            if (0 === i) return;
                            const a = t.querySelectorAll('input[type="radio"], option'),
                                r = n[i - 1].querySelector(":checked").value,
                                o = e.filter((t => t.available && t[`option${i}`] === r)).map((t => t[`option${i+1}`]));
                            this.setInputAvailability(a, o)
                        }))
                    }))
                }
                // setInputAvailability(t, e) {
                //     t.forEach((t => {
                //         const n = t.getAttribute("value"),
                //             i = e.includes(n);
                //         t.disabled = !i, "OPTION" === t.tagName && (t.innerText = i ? n : window.productStrings.unavailable_with_option.replace("[value]", n))
                //     }))
                // }

setInputAvailability(options, availableValues) {
    options.forEach(option => {
        const value = option.getAttribute("value");
        const isAvailable = availableValues.includes(value);
        
        if (option.tagName === "OPTION") {
            const unavailableText = window.productStrings?.unavailable_with_option || "[value]";
            option.innerText = isAvailable ? value : unavailableText.replace("[value]", value);
        }
    });
}

                updateImageSwatches() {
                    this.querySelectorAll("fieldset:has(.image-swatch)").forEach((t => {
                        const e = t.dataset.optionPosition,
                            n = t.querySelectorAll(".image-swatch");
                        for (const t of n) {
                            const n = [...this.options];
                            n[e - 1] = t.value;
                            const i = this.getVariantData().find((t => t.options[0] == n[0] && t.options[1] == n[1] && t.options[2] == n[2]));
                            if (!i) continue;
                            const a = t.labels[0],
                                r = a.querySelectorAll("img.variant-image"),
                                o = a.querySelector(`img[data-variant-id="${i.id}"]`),
                                s = a.querySelector(".image_swatch--text_value");
                            r.forEach((t => {
                                t.classList.add("u-hide")
                            })), s.classList.add("u-hide"), o ? o.classList.remove("u-hide") : s.classList.remove("u-hide")
                        }
                    }))
                }
           // updateMedia() {
           //          if (!this.currentVariant) return;
           //          if (!this.currentVariant.featured_media) return;
           //          const t = document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`);
           //          if (this.currentVariant.featured_media) {
           //              const e = this.currentVariant.featured_media.id;
           //              if (t.swiper) {
           //                  const n = t.swiper.slides;
           //                  for (const i of n)
           //                      if (!i.classList.contains("swiper-slide-duplicate")) {
           //                          const n = i.dataset.id,
           //                              a = i.dataset.swiperSlideIndex;
           //                          if (e == n) {
           //                              t.swiper.slideToLoop(a);
           //                              break
           //                          }
           //                      }
           //              } else {
           //                  const t = document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section} .swiper-wrapper`),
           //                      n = t.querySelector(`[data-id="${e}"]`);
           //                  n && t.prepend(n)
           //              }
           //              const n = document.querySelectorAll(".sticky-add-to-cart__image"),
           //                  i = this.currentVariant.id;
           //              n.forEach((t => {
           //                  t.dataset.variantId == i ? t.classList.remove("u-hide") : t.classList.add("u-hide")
           //              }))
           //          }
           //      }



  updateMediaThumbs() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const mainGallery = document.querySelector(`.swiper-container.product-top`).swiper;
    const thumbnailsGallery = document.querySelector(`.swiper-container.product-thumbs`).swiper;
    const featuredMediaId = this.currentVariant.featured_media.id;

    // Sync main gallery (product-top) Swiper
    if (mainGallery) {
        const mainSlides = mainGallery.slides;

        // Loop through main gallery slides to find the matching media ID
        for (let i = 0; i < mainSlides.length; i++) {
            const slideMediaId = mainSlides[i].getAttribute('data-id'); // Ensure data-id is correct

            if (slideMediaId == featuredMediaId) {
                // Slide to the matching image in the main gallery
                mainGallery.slideTo(i, 500); // Optional: 500ms slide transition
                break;
            }
        }
    }

    // Sync thumbnails gallery (product-thumbs) Swiper and add active class
    if (thumbnailsGallery) {
        const thumbSlides = thumbnailsGallery.slides;

        // Loop through thumbnail slides to find the matching media ID
        for (let i = 0; i < thumbSlides.length; i++) {
            const thumbMediaId = thumbSlides[i].getAttribute('data-id'); // Ensure data-id is correct

            // Remove 'active' class from all thumbnails
            thumbSlides[i].classList.remove('active-thumb');

            if (thumbMediaId == featuredMediaId) {
                // Slide to the matching thumbnail
                thumbnailsGallery.slideTo(i, 500); // Optional: 500ms slide transition
                thumbSlides[i].classList.add('active-thumb'); // Add active class to matching thumb
                break;
            }
        }
    }

    // Update sticky "Add to Cart" images for the selected variant
    const stickyImages = document.querySelectorAll(".sticky-add-to-cart__image");
    const currentVariantId = this.currentVariant.id;

    stickyImages.forEach(stickyImage => {
        if (stickyImage.dataset.variantId == currentVariantId) {
            stickyImage.classList.remove("u-hide");
        } else {
            stickyImage.classList.add("u-hide");
        }
    });
}





           

                updateURL() {
                    if (!this.currentVariant || "false" === this.dataset.updateUrl) return;
                    const t = `${this.dataset.url}?variant=${this.currentVariant.id}`;
                    window.history.replaceState({}, "", t)
                }
                updateVariantInput() {
                    document.querySelectorAll(`#form-product-${this.dataset.section}, #form-product-installment-${this.dataset.section}`).forEach((t => {
                        const e = t.querySelector('input[name="id"]');
                        e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
                            bubbles: !0
                        }))
                    }));
                    const t = this.getProductVariantSelects();
                    t.length > 1 && this.syncSelectValues(t)
                }
                syncSelectValues(t) {
                    t.forEach((t => {
                        t.querySelectorAll("select, fieldset").forEach((t => {
                            if ("SELECT" === t.tagName) this.currentVariant.options[t.dataset.optionPosition - 1] && (t.value = this.currentVariant.options[t.dataset.optionPosition - 1]);
                            else if ("FIELDSET" === t.tagName) {
                                const e = Array.from(t.querySelectorAll("input")).find((e => e.value === this.currentVariant.options[t.dataset.optionPosition - 1]));
                                e && (e.checked = !0)
                            }
                        }))
                    }))
                }
renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then(response => response.text())
    .then(htmlString => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        // Get the new price elements from the fetched HTML
        const newPrice = doc.getElementById(`price-${this.dataset.section}`);
        const newStickyPrice = doc.getElementById(`sticky-price-${this.dataset.section}`);
        const newPickupAvailability = doc.getElementById(`pickup-availability-${this.dataset.section}`);
        const newPickupModal = doc.getElementById(`pickup-availability-modal-${this.dataset.section}`);

        // Update OLD MRP
const currentOldMrp = document.querySelector(`.variant-old-mrp-wrapper`);
const newOldMrp = doc.querySelector(`.variant-old-mrp-wrapper`);

if (currentOldMrp && newOldMrp) {
  currentOldMrp.innerHTML = newOldMrp.innerHTML;
  currentOldMrp.classList.remove("u-invisible");
} else if (currentOldMrp) {
  // Hide if no value exists for this variant
  currentOldMrp.classList.add("u-invisible");
}
        
        // Update the main price on the page
        const currentPrice = document.getElementById(`price-${this.dataset.section}`);
        if (newPrice && currentPrice) {
            currentPrice.classList.remove("u-invisible");
            currentPrice.innerHTML = newPrice.innerHTML;
            currentPrice.classList = newPrice.classList;
        } else if (currentPrice) {
            currentPrice.classList.add("u-invisible");
        }

        // Update the sticky price
        const currentStickyPrice = document.getElementById(`sticky-price-${this.dataset.section}`);
        if (newStickyPrice && currentStickyPrice) {
            currentStickyPrice.classList.remove("u-invisible");
            currentStickyPrice.innerHTML = newStickyPrice.innerHTML;
            currentStickyPrice.classList = newStickyPrice.classList;
        } else if (currentStickyPrice) {
            currentStickyPrice.classList.add("u-invisible");
        }

        // Update pickup availability
        const currentPickupAvailability = document.getElementById(`pickup-availability-${this.dataset.section}`);
        if (newPickupAvailability && currentPickupAvailability) {
            currentPickupAvailability.innerHTML = newPickupAvailability.innerHTML;
        }

        const currentPickupModal = document.getElementById(`pickup-availability-modal-${this.dataset.section}`);
        if (newPickupModal && currentPickupModal) {
            currentPickupModal.innerHTML = newPickupModal.innerHTML;
        }

        // Update the price inside the "Add to Cart" button
        const addToCartPriceContainer = document.querySelector('.btn_price');
        if (newPrice && addToCartPriceContainer) {
            // Rendering the parsed price from the new HTML to the "Add to Cart" button
            addToCartPriceContainer.innerHTML = newPrice.innerHTML;
        }

        // Pickup availability modal actions
        const pickupAvailability = document.querySelector(".pickup-availability"),
            overlay = document.getElementById("overlay"),
            openButton = document.getElementById("pickup-availability-open"),
            closeButton = document.getElementById("pickup-availability-close");

        if (openButton) {
            openButton.addEventListener("click", function () {
                pickupAvailability.classList.add("open");
                overlay.classList.add("open");
                document.body.classList.add("active", "minicart");
            });
        }

        if (closeButton) {
            closeButton.addEventListener("click", function () {
                pickupAvailability.classList.remove("open");
                overlay.classList.remove("open");
                document.body.classList.remove("active", "minicart");
            });
        }
    });
}



                // toggleStockStatus(t) {
                //     const e = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                //         n = document.getElementById(`stock-status-${this.dataset.section}`);
                //     e && (t ? (e.forEach((t => {
                //         const e = t.querySelector('[name="add"]'),
                //             n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                //         e && (e.removeAttribute("disabled"), n.textContent = `${cartStrings.addToCart}`)
                //     })), n && (n.dataset.state = "in-stock")) : (e.forEach((t => {
                //         const e = t.querySelector('[name="add"]'),
                //             n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                //         e && (e.setAttribute("disabled", "disabled"), n.textContent = `${cartStrings.soldOut}`)
                //     })), n && (n.dataset.state = "out-of-stock")))
                // }

toggleStockStatus(isInStock) {
    const products = document.querySelectorAll(`.form-product-${this.dataset.section}`),
          stockStatus = document.getElementById(`stock-status-${this.dataset.section}`);
    
    if (stockStatus) stockStatus.classList.remove("u-invisible");

    products.forEach(product => {
        const addButton = product.querySelector('[name="add"]'),
              buttonText = product.querySelector('[name="add"] > span:not(.cart-icon)'),
              radios = product.querySelectorAll('input[type="radio"]'); // Select all radio buttons
        
        if (addButton && buttonText) {
            addButton.disabled = !isInStock;
            buttonText.textContent = isInStock ? "Add to cart" : "Sold out";
        }

        // Ensure radio buttons are always enabled
        radios.forEach(radio => {
            radio.disabled = false;
        });
    });

    if (stockStatus) {
        stockStatus.classList.toggle("in-stock", isInStock);
    }
}

                setUnavailable() {
                    const t = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                        e = document.getElementById(`stock-status-${this.dataset.section}`);
                    t.forEach((t => {
                        const n = t.querySelector('[name="add"]'),
                            i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        n && (i.textContent = `${cartStrings.unavailable}`, n.setAttribute("disabled", "disabled"), e && (e.dataset.state = "unavailable"))
                    }));
                    const n = document.getElementById(`price-${this.dataset.section}`),
                        i = document.getElementById(`sticky-price-${this.dataset.section}`);
                    n && this.setPriceUnavailable(n), i && this.setPriceUnavailable(i)
                }
                setPriceUnavailable(t) {
                    t.classList.remove("price--on-sale"), t.classList.add("price--sold-out"), t.querySelector(".price__regular .price-item.price-item--regular").textContent = window.productStrings.price_unavailable
                }
                getVariantData() {
                    return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
                }
                getProductVariantSelects() {
                    return document.querySelectorAll(`variant-selects[data-section=${this.dataset.section}]`)
                }
            }
            customElements.define("variant-selects", newradio);

          // radio blog

          class radioBlog extends HTMLElement {
                constructor() {
                    super();
                    this.addEventListener("change", this.onRadioButtonClick);
                }
            
                onRadioButtonClick() {
                    this.updateOptionsRadio(), this.updateMasterId()
                  console.log(this.currentVariant,'v')
                  , this.currentVariant ? (this.updateURL(),this.renderProductInfoRadio(),this.updateVariantInputRadio(), this.toggleStockStatus(this.currentVariant.available)) : this.setUnavailable()
                      // , this.currentVariant ? (this.updateMediaRadio(), this.updateURL(), this.renderProductInfoRadio(), this.updateVariantInputRadio(), this.toggleStockStatus(this.currentVariant.available)) : this.setUnavailable()
                }
            
                updateOptionsRadio() {
                  console.log(this.options = Array.from(this.querySelectorAll(".radio-input:checked"), (t => t.value)))
                  this.options = Array.from(this.querySelectorAll(".radio-input:checked"), (t => t.value));
              }
            
                updateMasterId() {
                    this.currentVariant = this.getVariantDataRadio().find((t => !t.options.map(((t, e) => this.options[e] === t)).includes(!1)));
                }
            
//                updateMediaRadio() {
//       if (!this.currentVariant) return;
//                       if (!this.currentVariant.featured_media) return;
//                       const t = document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section} .product-top .swiper-wrapper`);
//                       if (this.currentVariant.featured_media) {
//                           const e = this.currentVariant.featured_media.id;
//                           document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper ? document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper.slides.forEach((t => {
//                               if (!t.classList.contains("swiper-slide-duplicate")) {
//                                   const i = t.getAttribute("data-id"),
//                                       n = t.getAttribute("data-swiper-slide-index");
//                                   e == i && document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper.slideToLoop(n);
//                               }
//                           })) : t.prepend(t.querySelector('[data-id="' + e + '"]')), document.querySelector(".sticky-add-to-cart__image") && (document.querySelector(".sticky-add-to-cart__image").src = this.currentVariant.featured_media.preview_image.src);
//                       }
// }

            


                updateURL() {
                  console.log(this.currentVariant.id,'url')
                    this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
                }
            
               updateVariantInputRadio() {
                    document.querySelectorAll(`#form-product-${this.dataset.section}, #form-product-installment-${this.dataset.section}`).forEach((t => {
                        const e = t.querySelector('input[name="id"]');
                        e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
                            bubbles: !0
                        }))
                    }))
                    //   , document.querySelector(".product-converter") && document.querySelectorAll("variant-radios").forEach((t => {
                    //     this.currentVariant.option1 && (t.querySelectorAll("input")[0].value = this.currentVariant.option1), this.currentVariant.option2 && (t.querySelectorAll("input")[1].value = this.currentVariant.option2), this.currentVariant.option3 && (t.querySelectorAll("input")[2].value = this.currentVariant.option3)
                    // }))
                }


                renderProductInfoRadio() {
                    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`).then((t => t.text())).then((i => {
                        const n = (new DOMParser).parseFromString(i, "text/html"),
                            o = document.getElementById(`price-${this.dataset.section}`),
                            r = n.getElementById(`price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`),
                            a = document.getElementById(`sticky-price-${this.dataset.section}`),
                            s = n.getElementById(`sticky-price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`),
                            c = document.getElementById(`pickup-availability-${this.dataset.section}`),
                            d = n.getElementById(`pickup-availability-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`),
                            l = document.getElementById(`pickup-availability-modal-${this.dataset.section}`),
                            u = n.getElementById(`pickup-availability-modal-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`);
                        r && o ? (o.classList.remove("u-invisible"), o.innerHTML = r.innerHTML) : o.classList.add("u-invisible"), s && a ? (a.classList.remove("u-invisible"), a.innerHTML = s.innerHTML) : a && a.classList.add("u-invisible"), d && c && (c.innerHTML = d.innerHTML), u && l && (l.innerHTML = u.innerHTML);
                        const p = document.querySelector(".pickup-availability"),
                            h = document.getElementById("overlay"),
                            y = document.getElementById("pickup-availability-open"),
                            m = document.getElementById("pickup-availability-close");
                        y && document.getElementById("pickup-availability-open").addEventListener("click", (function() {
                            p.classList.add("open"), h.classList.add("open"), document.body.classList.add("active", "minicart"), (0, t.hO)(!0), e()
                        })), m && document.getElementById("pickup-availability-close").addEventListener("click", (function() {
                            p.classList.remove("open"), document.body.classList.remove("active", "minicart"), (0, t.hO)(!1), overlay.classList.remove("open", "overlay--all"), (0, t.zx)(p)
                        }))
                    }))
                }
                toggleStockStatus(t) {
                    const e = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                        i = document.getElementById(`stock-status-${this.dataset.section}`);
                    i && i.classList.remove("u-invisible"), e && (t ? (e.forEach((t => {
                        const e = t.querySelector('[name="add"]'),
                            i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        e && (e.removeAttribute("disabled"), i.textContent = "Add to cart")
                    })), i && i.classList.add("in-stock")) : (e.forEach((t => {
                        const e = t.querySelector('[name="add"]'),
                            i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        e && (e.setAttribute("disabled", "disabled"), i.textContent = "Sold out")
                    })), i && i.classList.remove("in-stock")))
                }
                setUnavailable() {
                    const t = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                        e = document.getElementById(`stock-status-${this.dataset.section}`);
                    t.forEach((t => {
                        const i = t.querySelector('[name="add"]'),
                            n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                        i && (n.textContent = window.cartStrings.unavailable, i.setAttribute("disabled", "disabled"), e && e.classList.add("u-invisible"))
                    }));
                    const i = document.getElementById(`price-${this.dataset.section}`),
                        n = document.getElementById(`sticky-price-${this.dataset.section}`);
                    i && i.classList.add("u-invisible"), n && n.classList.add("u-invisible")
                }
                getVariantDataRadio() {
              if (!this.variantData) {
                  const jsonDataElement = this.querySelector('[type="application/json"]');
                  if (jsonDataElement) {
                      const jsonData = JSON.parse(jsonDataElement.textContent);
                      this.variantData = jsonData;
                  } else {
                      console.error("JSON data element not found");
                  }
              }
              return this.variantData;
              }
            // reloadPage(){
            //    location.reload();
            // }

            }
            customElements.define("variant-radios-blog", radioBlog)


// ===========================  dropdown on protein collection page ===========================================

class newradioCollection extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();

        if (this.currentVariant) {
            this.updateURL();
            this.renderProductInfo();
            this.updateVariantInput();
            this.toggleStockStatus(this.currentVariant.available);
        } else {
            this.setUnavailable();
        }
    }

    updateOptions() {
        // Scope to the current product card
        const productCard = this.closest(".protein-card");
        this.options = Array.from(
            productCard.querySelectorAll("select, fieldset"),
            (t) =>
                t.tagName === "SELECT"
                    ? t.value
                    : Array.from(t.querySelectorAll("input")).find((input) => input.checked)?.value
        );
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) =>
            variant.options.every((option, index) => this.options[index] === option)
        );
    }

    updateVariantStatuses() {
        const productCard = this.closest(".protein-card");
        const selectedOption = productCard.querySelector(":checked").value;

        const availableVariants = this.getVariantData().filter((variant) => variant.options[0] === selectedOption);

        const variantSelectGroups = productCard.querySelectorAll("select, fieldset");

        variantSelectGroups.forEach((group, index) => {
            if (index === 0) return;
            const inputs = group.querySelectorAll('input[type="radio"], option');
            const prevSelectedValue = variantSelectGroups[index - 1].querySelector(":checked").value;

            const availableOptions = availableVariants
                .filter((variant) => variant.available && variant[`option${index}`] === prevSelectedValue)
                .map((variant) => variant[`option${index + 1}`]);

            this.setInputAvailability(inputs, availableOptions);
        });
    }

    setInputAvailability(inputs, availableOptions) {
        const unavailableText = window.productStrings?.unavailable_with_option || "[value]";

        inputs.forEach((input) => {
            const value = input.getAttribute("value");
            const isAvailable = availableOptions.includes(value);

            if (input.tagName === "OPTION") {
                input.innerText = isAvailable ? value : unavailableText.replace("[value]", value);
                input.classList.toggle("unavailable-option", !isAvailable);
            }

            if (input.type === "radio") {
                input.disabled = false;
                input.classList.toggle("unavailable-option", !isAvailable);
            }
        });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;

        const url = `${this.dataset.url}?variant=${this.currentVariant.id}`;
        window.history.replaceState({}, "", url);
    }

    updateVariantInput() {
        const productCard = this.closest(".protein-card");
        if (!productCard) return;

        const variantInput = productCard.querySelector('input[name="id"]');
        if (variantInput) {
            variantInput.value = this.currentVariant.id;
            variantInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }

    renderProductInfo() {
        const productCard = this.closest(".protein-card");
        if (!productCard) return;

        const productId = productCard.dataset.product;
        const priceId = `price-${this.dataset.section}-${productId}`;
        const currentPriceId = `price-${this.dataset.section}-${productId}`;

        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((htmlString) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, "text/html");

                const newPrice = doc.getElementById(priceId);
                const currentPrice = productCard.querySelector(`#${currentPriceId}`);

                if (newPrice && currentPrice) {
                    currentPrice.classList.remove("u-invisible");
                    currentPrice.innerHTML = newPrice.innerHTML;
                    currentPrice.classList = newPrice.classList;
                } else if (currentPrice) {
                    currentPrice.classList.add("u-invisible");
                }
            });
    }

    toggleStockStatus(isInStock) {
        const productCard = this.closest(".protein-card");
        if (!productCard) return;

        const addButton = productCard.querySelector('[name="add"]');
        const buttonText = addButton ? addButton.querySelector('span:not(.cart-icon)') : null;

        if (addButton && buttonText) {
            addButton.disabled = !isInStock;
            buttonText.textContent = isInStock ? "Add to cart" : "Sold out";
        }
    }

    setUnavailable() {
        const productCard = this.closest(".protein-card");
        if (!productCard) return;

        const addButton = productCard.querySelector('[name="add"]');
        const buttonText = addButton ? addButton.querySelector('span:not(.cart-icon)') : null;

        if (addButton && buttonText) {
            addButton.disabled = true;
            buttonText.textContent = window.cartStrings.unavailable;
        }
    }

    getVariantData() {
        if (!this.variantData) {
            const jsonData = this.querySelector('[type="application/json"]');
            this.variantData = JSON.parse(jsonData.textContent);
        }
        return this.variantData;
    }
}
customElements.define("variant-selects-collection", newradioCollection);


          
        }()
}();
